import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IChangePassword } from 'src/app/models/IChangePassword';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {
  _errorMessage:string=''; 
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
  }
  fs:string="";
  oldPassword:string;
  newPassword:string;
  confirmPassword:string;
  dir:string='';
  constructor(private httpHelper:HttphelperService,private messageService:MessageService,private router:Router) {
    let currentLnaguage =  localStorage.getItem('lang');
    if(currentLnaguage == null){
        this.dir = "ltr"; 
    }
    else
    {
      if(currentLnaguage == 'ar'){
        this.dir = "rtl"; 
      }
      else{
        this.dir = "ltr"; 
      }
    }
   }

  ngOnInit(): void {
  }
  change():void
  {
    if(this.oldPassword == "" || this.oldPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Old Password", life: 2000});
      //this.alert.warn("Please Enter Old Password");
      return;
    }
    if(this.newPassword == "" || this.newPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter New Password", life: 2000});
      //this.alert.warn("Please Enter New Password");
      return;
    }
    if(this.confirmPassword == "" || this.confirmPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Confirm Password", life: 2000});
      //this.alert.warn("Please Enter Confirm Password");
      return;
    }
    if(this.newPassword != this.confirmPassword)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Confirm Password Doesn't Match New Password", life: 2000});
      //this.alert.warn("Confirm Password Doesn't Match New Password");
      return;
    }
    var url = "api/Account/ChangePassword";
    let model : IChangePassword = {OldPassword:this.oldPassword , NewPassword:this.newPassword , ConfirmPassword:this.confirmPassword};
    this.httpHelper.postRequest(url,true,model).subscribe({
      next: res => {
           if(res.Success)
           {
             this.messageService.add({severity: 'success', summary: 'Success', detail:res.Message, life: 2000});
             //this.alert.success(res.Message);
             this.router.navigate(['/history']);
           }
           else
           this.messageService.add({severity: 'error', summary: 'Error', detail:res.Message, life: 2000});
            //this.alert.error(res.Message);
      },
      error: err => this.errorMessage = err
    });
  }
}
